import Icon from '../components/Icon.vue'

Icon.register({
  horse: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M575.9 76.6l0.1 77.7v0c0 12-9 25.3-20.1 29.7l-32.6 13c-15.4 6.2-33-0.5-40.5-15.4l-18.9-37.7-16-7.1v102.5c0 0.2 0.1 0.4 0.1 0.6 0 30.5-12.3 58-32 78.2v177.8c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-150.4l-134-22.3-23.8 63.6 26.3 105.3c2.5 10.1-5.1 19.9-15.5 19.9h-66 0c-6.9 0-13.8-5.4-15.5-12.1l-24.8-99.4c-1.1-4.2-1.9-11.2-1.9-15.5 0-6.4 1.8-16.5 4.1-22.5l25.7-68.6c-18.7-17.5-30.5-42.2-30.5-69.9 0-2.6 0.6-5.1 0.8-7.7-9.9 7.3-16.8 18.5-16.8 31.7v56c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-56c0-48.5 39.5-88 88-88v1.1c17.6-20.1 43.2-33.1 72-33.1h159.9c0-70.7 57.3-128 128-128h120c5.1 0 8.9 4.7 7.9 9.6-2.7 13.2-11.1 23.8-22.2 30.7 5.1 5.4 9.9 10.5 13.7 14.5 5.6 5.9 8.6 13.7 8.6 21.8zM511.9 96c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/horse.js
// module id = 1408
// module chunks = 0